var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3917 13.3344H2.66769C2.54143 13.3344 2.42601 13.263 2.36955 13.1501C2.31308 13.0372 2.32527 12.902 2.40102 12.801L2.66769 12.4457V6.66769C2.66769 5.78102 2.88369 4.94502 3.26702 4.20969L0.929688 1.87302L1.87302 0.929688L15.0724 14.1297L14.129 15.0724L12.3917 13.3344ZM4.27302 5.21558C4.09277 5.67843 4.00052 6.17087 4.00102 6.66758V12.0009H11.0584L4.27302 5.21558ZM13.3343 10.525L12.001 9.1917V6.6677C12.001 5.23916 11.2399 3.91961 10.004 3.20462C8.76813 2.48963 7.24482 2.48764 6.00705 3.1994L5.04102 2.23104C6.6775 1.1392 8.78215 1.0369 10.5168 1.96488C12.2515 2.89287 13.3344 4.70042 13.3343 6.6677V10.525V10.525ZM6.33435 14.001H9.66768C9.66768 14.5964 9.35002 15.1466 8.83435 15.4444C8.31868 15.7421 7.68335 15.7421 7.16768 15.4444C6.65202 15.1466 6.33435 14.5964 6.33435 14.001Z",
    fill: "#29BAA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlertIcon);
export default __webpack_public_path__ + "static/media/successAlertIcon.0a3a7167a482b1a0ad6896371189b2f1.svg";
export { ForwardRef as ReactComponent };